import React from 'react';
import styled from 'styled-components';
import { green, red, orange } from 'utils/style/colors';
import InfoBox from 'components/Report/InfoBox';
import { roundToDynamicFloating } from '../../Chart/analyseUtils';
import { ITemplateReportValues } from 'store/templates/templatesSlice';
import { ITemplateReportOptions } from 'store/tasks/tasksType';

interface IReportInfoBoxesProps {
  type: 'main' | 'secondary' | 'verify' | 'assignee';
  templateReportOptions: ITemplateReportOptions;
  tableData: ITemplateReportValues;
  horizontal?: boolean;
}

interface IBoxesWrapper {
  horizontal?: boolean;
}

const BoxesWrapper = styled('div')<IBoxesWrapper>`
  display: flex;
  flex-direction: ${(props) => (props.horizontal ? 'row' : 'column')};
`;

class ReportInfoBoxes extends React.PureComponent<IReportInfoBoxesProps> {
  public static defaultProps = {
    horizontal: false,
  };

  render() {
    const { type, templateReportOptions, tableData, horizontal } = this.props;

    const totalMain =
      (tableData.completedTaskCountMain
        ? tableData.completedTaskCountMain
        : 0) +
      (tableData.inProgressTaskCountMain
        ? tableData.inProgressTaskCountMain
        : 0) +
      (tableData.notStartedTaskCountMain
        ? tableData.notStartedTaskCountMain
        : 0);
    const totalSecondary =
      (tableData.completedTaskCountSecondary
        ? tableData.completedTaskCountSecondary
        : 0) +
      (tableData.inProgressTaskCountSecondary
        ? tableData.inProgressTaskCountSecondary
        : 0) +
      (tableData.notStartedTaskCountSecondary
        ? tableData.notStartedTaskCountSecondary
        : 0);
    const totalVerifier =
      (tableData.completedTaskCountVerifier
        ? tableData.completedTaskCountVerifier
        : 0) +
      (tableData.rejectedTaskCountVerifier
        ? tableData.rejectedTaskCountVerifier
        : 0) +
      (tableData.notStartedTaskCountVerifier
        ? tableData.notStartedTaskCountVerifier
        : 0);
    const totalAssignment =
      (tableData.completedAssignmentCount
        ? tableData.completedAssignmentCount
        : 0) +
      (tableData.inProgressAssignmentCount
        ? tableData.inProgressAssignmentCount
        : 0) +
      (tableData.notStartedAssignmentCount
        ? tableData.notStartedAssignmentCount
        : 0);

    if (type === 'main') {
      return (
        <BoxesWrapper horizontal={horizontal}>
          {templateReportOptions.completedTaskCountMain &&
          tableData.completedTaskCountMain !== undefined ? (
            <InfoBox
              value={tableData.completedTaskCountMain}
              text={templateReportOptions.completedTaskCountMain}
              percentage={
                totalMain
                  ? roundToDynamicFloating(
                      (tableData.completedTaskCountMain / totalMain) * 100
                    )
                  : 0
              }
              totalCount={totalMain}
              color={green}
            />
          ) : null}
          {templateReportOptions.inProgressTaskCountMain &&
          tableData.inProgressTaskCountMain !== undefined ? (
            <InfoBox
              value={tableData.inProgressTaskCountMain}
              text={templateReportOptions.inProgressTaskCountMain}
              percentage={
                totalMain
                  ? roundToDynamicFloating(
                      (tableData.inProgressTaskCountMain / totalMain) * 100
                    )
                  : 0
              }
              totalCount={totalMain}
              color={orange}
            />
          ) : null}
          {templateReportOptions.notStartedTaskCountMain &&
          tableData.notStartedTaskCountMain !== undefined ? (
            <InfoBox
              value={tableData.notStartedTaskCountMain}
              text={templateReportOptions.notStartedTaskCountMain}
              percentage={
                totalMain
                  ? roundToDynamicFloating(
                      (tableData.notStartedTaskCountMain / totalMain) * 100
                    )
                  : 0
              }
              totalCount={totalMain}
              color={red}
            />
          ) : null}
          {templateReportOptions.averageProgressMain &&
          tableData.averageProgressMain !== undefined ? (
            <InfoBox
              value="-"
              text={templateReportOptions.averageProgressMain}
              percentage={roundToDynamicFloating(tableData.averageProgressMain)}
            />
          ) : null}
        </BoxesWrapper>
      );
    } else if (type === 'secondary') {
      return (
        <BoxesWrapper horizontal={horizontal}>
          {templateReportOptions.completedTaskCountSecondary &&
          tableData.completedTaskCountSecondary !== undefined ? (
            <InfoBox
              value={tableData.completedTaskCountSecondary}
              text={templateReportOptions.completedTaskCountSecondary}
              percentage={
                totalSecondary
                  ? roundToDynamicFloating(
                      (tableData.completedTaskCountSecondary / totalSecondary) *
                        100
                    )
                  : 0
              }
              totalCount={totalSecondary}
              color={green}
            />
          ) : null}
          {templateReportOptions.inProgressTaskCountSecondary &&
          tableData.inProgressTaskCountSecondary !== undefined ? (
            <InfoBox
              value={tableData.inProgressTaskCountSecondary}
              text={templateReportOptions.inProgressTaskCountSecondary}
              percentage={
                totalSecondary
                  ? roundToDynamicFloating(
                      (tableData.inProgressTaskCountSecondary /
                        totalSecondary) *
                        100
                    )
                  : 0
              }
              totalCount={totalSecondary}
              color={orange}
            />
          ) : null}
          {templateReportOptions.notStartedTaskCountSecondary &&
          tableData.notStartedTaskCountSecondary !== undefined ? (
            <InfoBox
              value={tableData.notStartedTaskCountSecondary}
              text={templateReportOptions.notStartedTaskCountSecondary}
              percentage={
                totalSecondary
                  ? roundToDynamicFloating(
                      (tableData.notStartedTaskCountSecondary /
                        totalSecondary) *
                        100
                    )
                  : 0
              }
              totalCount={totalSecondary}
              color={red}
            />
          ) : null}
          {templateReportOptions.averageProgressSecondary &&
          tableData.averageProgressSecondary !== undefined ? (
            <InfoBox
              value="-"
              text={templateReportOptions.averageProgressSecondary}
              percentage={roundToDynamicFloating(
                tableData.averageProgressSecondary
              )}
            />
          ) : null}
        </BoxesWrapper>
      );
    } else if (type === 'verify') {
      return (
        <BoxesWrapper horizontal={horizontal}>
          {templateReportOptions.completedTaskCountVerifier &&
          tableData.completedTaskCountVerifier !== undefined ? (
            <InfoBox
              value={tableData.completedTaskCountVerifier}
              text={templateReportOptions.completedTaskCountVerifier}
              percentage={
                totalVerifier
                  ? roundToDynamicFloating(
                      (tableData.completedTaskCountVerifier / totalVerifier) *
                        100
                    )
                  : 0
              }
              totalCount={totalVerifier}
              color={green}
            />
          ) : null}
          {templateReportOptions.rejectedTaskCountVerifier &&
          tableData.rejectedTaskCountVerifier !== undefined ? (
            <InfoBox
              value={tableData.rejectedTaskCountVerifier}
              text={templateReportOptions.rejectedTaskCountVerifier}
              percentage={
                totalVerifier
                  ? roundToDynamicFloating(
                      (tableData.rejectedTaskCountVerifier / totalVerifier) *
                        100
                    )
                  : 0
              }
              totalCount={totalVerifier}
              color={orange}
            />
          ) : null}
          {templateReportOptions.notStartedTaskCountVerifier &&
          tableData.notStartedTaskCountVerifier !== undefined ? (
            <InfoBox
              value={tableData.notStartedTaskCountVerifier}
              text={templateReportOptions.notStartedTaskCountVerifier}
              percentage={
                totalVerifier
                  ? roundToDynamicFloating(
                      (tableData.notStartedTaskCountVerifier / totalVerifier) *
                        100
                    )
                  : 0
              }
              totalCount={totalVerifier}
              color={red}
            />
          ) : null}
        </BoxesWrapper>
      );
    } else if (type === 'assignee') {
      return (
        <BoxesWrapper horizontal={horizontal}>
          {templateReportOptions.completedAssignmentCount &&
          tableData.completedAssignmentCount !== undefined ? (
            <InfoBox
              value={tableData.completedAssignmentCount}
              text={templateReportOptions.completedAssignmentCount}
              percentage={
                totalAssignment
                  ? roundToDynamicFloating(
                      (tableData.completedAssignmentCount / totalAssignment) *
                        100
                    )
                  : 0
              }
              totalCount={totalAssignment}
            />
          ) : null}
          {templateReportOptions.inProgressAssignmentCount &&
          tableData.inProgressAssignmentCount !== undefined ? (
            <InfoBox
              value={tableData.inProgressAssignmentCount}
              text={templateReportOptions.inProgressAssignmentCount}
              percentage={
                totalAssignment
                  ? roundToDynamicFloating(
                      (tableData.inProgressAssignmentCount / totalAssignment) *
                        100
                    )
                  : 0
              }
              totalCount={totalAssignment}
            />
          ) : null}
          {templateReportOptions.notStartedAssignmentCount &&
          tableData.notStartedAssignmentCount !== undefined ? (
            <InfoBox
              value={tableData.notStartedAssignmentCount}
              text={templateReportOptions.notStartedAssignmentCount}
              percentage={
                totalAssignment
                  ? roundToDynamicFloating(
                      (tableData.notStartedAssignmentCount / totalAssignment) *
                        100
                    )
                  : 0
              }
              totalCount={totalAssignment}
            />
          ) : null}
          {templateReportOptions.averageAssignmentProgress &&
          tableData.averageAssignmentProgress !== undefined ? (
            <InfoBox
              value="-"
              text={templateReportOptions.averageAssignmentProgress}
              percentage={roundToDynamicFloating(
                tableData.averageAssignmentProgress
              )}
            />
          ) : null}
        </BoxesWrapper>
      );
    }
    return null;
  }
}

export default ReportInfoBoxes;
